// extracted by mini-css-extract-plugin
export default {"header":"DetailsHeader_header__WMsks","img":"DetailsHeader_img__jASTO"};